import { useQuery } from "react-query";

import { fetchCookiesSettings } from "~/api";

import { transformCookiesSettingsResponse } from "./useCookiesSettings.util";

export const useCookiesStatus = () => {
  const { data: response } = useQuery(
    "cookiesSettingsQuery",
    fetchCookiesSettings
  );

  return {
    isCookiesDisabled: transformCookiesSettingsResponse(response),
  };
};
